import requests from "./httpService";

const AirportPickupPeriodicHikeDayServices = {
  getAllAirportPickupPeriodicHikeDay: async (body) => {
    return requests.get(`/airportPickupPeriodicHikeDay/`);
  },

  addAirportPickupPeriodicHikeDay: async (body) => {
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0'); 
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
  
    const formattedBody = {
      ...body,
      start_date: formatDate(body.start_date), 
      end_date: formatDate(body.end_date),
    };

    
    return requests.post(`/airportPickupPeriodicHikeDay/add`, formattedBody);
  },
  getAirportPickupPeriodicHikeDayById: async (id) => {

    return requests.get(`/airportPickupPeriodicHikeDay/${id}`);
  },

  updateAirportPickupPeriodicHikeDay: async (id, body) => {
    const formatDate = (date) => {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0'); 
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };
  
    const formattedBody = {
      ...body,
      start_date: formatDate(body.start_date), 
      end_date: formatDate(body.end_date),
    };
    return requests.put(`/airportPickupPeriodicHikeDay/update/${id}`, formattedBody);
  },

  deleteAirportPickupPeriodicHikeDay: async (id) => {
    return requests.delete(`/airportPickupPeriodicHikeDay/delete/${id}`);
  },
};

export default AirportPickupPeriodicHikeDayServices;
